// extracted by mini-css-extract-plugin
module.exports = {"longWord":"ListingLink_longWord__3E_6W"};